(function(angular) {
    'use strict';

    angular.module('app').controller('ContactUsCtrl', [
        ContactUsCtrl,
    ]);

    function ContactUsCtrl() { }
})(window.angular);
